import styled from 'styled-components';

export const FileDrop = styled.label<{ $hasFile: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1.5px dashed ${({ $hasFile }) => ($hasFile ? '#5fb98a' : '#c9c9c9')};
  background: ${({ $hasFile }) => ($hasFile ? '#eef8f2' : '#fafafa')};
  color: ${({ $hasFile }) => ($hasFile ? '#23764a' : '#696969')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;

  input {
    display: none;
  }
`;
